module.exports = __webpack_public_path__ + "img/ru_AnswerTurtle.6813e705.svg";